export const CTMY_HOME_URL = "/cmty_home";
export const CTMY_REG_POST_URL = "/cmty_reg_post";
export const CTMY_BASE_POST_URL = "/cmty_base_post";

export const CTMY_CATG_JOB = 1;
export const CTMY_CATG_JOB_NAME = "취업";
export const CTMY_CATG_JOB_URL_NAME = "cmty_job";
export const CTMY_CATG_JOB_URL = "/" + CTMY_CATG_JOB_URL_NAME;

// 07.09.2025 방문자가 많아지면 활성화
// export const CTMY_CATG_BIZ= 2;
// export const CTMY_CATG_BIZ_NAME = "사업";//나중에 창업변경
// export const CTMY_CATG_BIZ_URL_NAME = "cmty_biz";
// export const CTMY_CATG_BIZ_URL = "/" + CTMY_CATG_BIZ_URL_NAME;

export const CTMY_CATG_VISA= 3;
export const CTMY_CATG_VISA_NAME = "비자";
export const CTMY_CATG_VISA_URL_NAME = "cmty_visa";
export const CTMY_CATG_VISA_URL = "/" + CTMY_CATG_VISA_URL_NAME;

export const CTMY_CATG_LANG= 4;
export const CTMY_CATG_LANG_NAME = "어학";
export const CTMY_CATG_LANG_URL_NAME = "cmty_lang";
export const CTMY_CATG_LANG_URL = "/" + CTMY_CATG_LANG_URL_NAME;

export const CTMY_CATG_STUDY= 5;
export const CTMY_CATG_STUDY_NAME = "유학";
export const CTMY_CATG_STUDY_URL_NAME = "cmty_study";
export const CTMY_CATG_STUDY_URL = "/" + CTMY_CATG_STUDY_URL_NAME;

export const CTMY_CATG_LIFE= 6;
export const CTMY_CATG_LIFE_NAME = "생활";
export const CTMY_CATG_LIFE_URL_NAME = "cmty_life";
export const CTMY_CATG_LIFE_URL = "/" + CTMY_CATG_LIFE_URL_NAME;

export const CTMY_CATG_HOUSE= 7;
export const CTMY_CATG_HOUSE_NAME = "집";
export const CTMY_CATG_HOUSE_URL_NAME = "cmty_house";
export const CTMY_CATG_HOUSE_URL = "/" + CTMY_CATG_HOUSE_URL_NAME;

// 07.09.2025 activate later
// export const CTMY_CATG_MARKET= 8;
// export const CTMY_CATG_MARKET_NAME = "벼룩시장";
// export const CTMY_CATG_MARKET_URL_NAME = "cmty_market";
// export const CTMY_CATG_MARKET_URL = "/" + CTMY_CATG_MARKET_URL_NAME;

// 07.09.2025 activate later
// export const CTMY_CATG_EVENT= 9;
// export const CTMY_CATG_EVENT_NAME = "행사";
// export const CTMY_CATG_EVENT_URL_NAME = "cmty_event";
// export const CTMY_CATG_EVENT_URL = "/" + CTMY_CATG_EVENT_URL_NAME;

// 07.09.2025 activate later
// export const CTMY_CATG_EAT= 10;
// export const CTMY_CATG_EAT_NAME = "맛집";
// export const CTMY_CATG_EAT_URL_NAME = "cmty_eat";
// export const CTMY_CATG_EAT_URL = "/" + CTMY_CATG_EAT_URL_NAME;

// 07.09.2025 activate later
// export const CTMY_CATG_MEET= 11;
// export const CTMY_CATG_MEET_NAME = "친목";
// export const CTMY_CATG_MEET_URL_NAME = "cmty_meet";
// export const CTMY_CATG_MEET_URL = "/" + CTMY_CATG_MEET_URL_NAME;

export const CTMY_CATG_HEALTHCARE= 12;
export const CTMY_CATG_HEALTHCARE_NAME = "의료";
export const CTMY_CATG_HEALTHCARE_URL_NAME = "cmty_healthcare";
export const CTMY_CATG_HEALTHCARE_URL = "/" + CTMY_CATG_HEALTHCARE_URL_NAME;

export const CTMY_CATG_INSURANCE= 13;
export const CTMY_CATG_INSURANCE_NAME = "보험";
export const CTMY_CATG_INSURANCE_URL_NAME = "cmty_insurance";
export const CTMY_CATG_INSURANCE_URL = "/" + CTMY_CATG_INSURANCE_URL_NAME;

export const CTMY_CATG_BANK= 14;
export const CTMY_CATG_BANK_NAME = "은행";
export const CTMY_CATG_BANK_URL_NAME = "cmty_bank";
export const CTMY_CATG_BANK_URL = "/" + CTMY_CATG_BANK_URL_NAME;

export const COMMENT_MESSAGE_NO_AUTH = "댓글은 로그인이 필요한 서비스입니다."
export const REPLY_MESSAGE_NO_AUTH = "답글은 로그인이 필요한 서비스입니다."

export const CONSTRAINED_TITLE_LENGTH_SMALL = 35
export const CONSTRAINED_TITLE_LENGTH_LARGE = 50

export function getCatgNameByValue(value){
    let catgName;
    switch(value) {
        case 1:
            catgName = CTMY_CATG_JOB_NAME;
            break;
        // case 2:
        //     catgName = CTMY_CATG_BIZ_NAME;
        //     break;
        case 3:
            catgName = CTMY_CATG_VISA_NAME;
            break;
        case 4:
            catgName = CTMY_CATG_LANG_NAME;
            break;
        case 5:
            catgName = CTMY_CATG_STUDY_NAME;
            break;
        case 6:
            catgName = CTMY_CATG_LIFE_NAME;
            break;
        case 7:
            catgName = CTMY_CATG_HOUSE_NAME;
            break;
        // case 8:
        //     catgName = CTMY_CATG_MARKET_NAME;
        //     break;
        // case 9:
        //     catgName = CTMY_CATG_EVENT_NAME;
        //     break;
        // case 10:
        //     catgName = CTMY_CATG_EAT_NAME;
        //     break;
        // case 11:
        //     catgName = CTMY_CATG_MEET_NAME;
        //     break;
        case 12:
            catgName = CTMY_CATG_HEALTHCARE_NAME;
            break;
        case 13:
            catgName = CTMY_CATG_INSURANCE_NAME;
            break;
        case 14:
            catgName = CTMY_CATG_BANK_NAME;
            break;
        default:
            catgName = 'Invalid';
    }
    return catgName
}

export function getCatgUrlByValue(value){
    let catgUrl;
    switch(value) {
        case 1:
            catgUrl = CTMY_CATG_JOB_URL;
            break;
        // case 2:
        //     catgUrl = CTMY_CATG_BIZ_URL;
        //     break;
        case 3:
            catgUrl = CTMY_CATG_VISA_URL;
            break;
        case 4:
            catgUrl = CTMY_CATG_LANG_URL;
            break;
        case 5:
            catgUrl = CTMY_CATG_STUDY_URL;
            break;
        case 6:
            catgUrl = CTMY_CATG_LIFE_URL;
            break;
        case 7:
            catgUrl = CTMY_CATG_HOUSE_URL;
            break;
        // case 8:
        //     catgUrl = CTMY_CATG_MARKET_URL;
        //     break;
        // case 9:
        //     catgUrl = CTMY_CATG_EVENT_URL;
        //     break;
        // case 10:
        //     catgUrl = CTMY_CATG_EAT_URL;
        //     break;
        // case 11:
        //     catgUrl = CTMY_CATG_MEET_URL;
        //     break;
        case 12:
            catgUrl = CTMY_CATG_HEALTHCARE_URL;
            break;
        case 13:
            catgUrl = CTMY_CATG_INSURANCE_URL;
            break;
        case 14:
            catgUrl = CTMY_CATG_BANK_URL;
            break;
        default:
            catgUrl = 'Invalid';
    }
    return catgUrl
}